import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

const PageLoader = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Show loader when route changes
    setLoading(true);
    
    // Hide loader after a short delay (simulates page load)
    const timer = setTimeout(() => {
      setLoading(false);
    }, 300);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  if (!loading) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[9999] transition-opacity">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-yellow-500 animate-spin mx-auto mb-3" />
        <p className="text-white text-sm">Loading...</p>
      </div>
    </div>
  );
};

export default PageLoader;
